module.exports = __webpack_public_path__ + "img/Logo_Ssangyong.db325d4f.svg";